angular
  .module('inspinia')
  .controller('UploadCompletedModalCtrl', function ($scope, $modalInstance, files, normalizedFiles) {
    const init = function () {
      $scope.files = files ? files : [];
      $scope.numberOfErrors = $scope.files.length;
      $scope.showErrorDetails = false;

      // ファイル名を正規化（先頭ドット削除・自動生成等）したファイル
      var rawNormalizedFiles = normalizedFiles ? normalizedFiles : [];
      $scope.normalizedFiles = rawNormalizedFiles.map(function (file) {
        return {
          originalName: file.name,
          name: file.replacedName ? file.replacedName : file.name,
        };
      });
      // 通知メッセージ（INFO）を重複排除して表示する
      $scope.normalizedMessages = rawNormalizedFiles.reduce(function (messages, file) {
        (file.messages || []).forEach(function (message) {
          if (message.severity === 'INFO' && message.text && messages.indexOf(message.text) === -1) {
            messages.push(message.text);
          }
        });
        return messages;
      }, []);
      $scope.showNormalizedDetails = false;
    };

    $scope.toggleDetails = function () {
      $scope.showErrorDetails = !$scope.showErrorDetails;
    };

    $scope.toggleNormalizedDetails = function () {
      $scope.showNormalizedDetails = !$scope.showNormalizedDetails;
    };

    init();
  });
